import React from "react";
import "../../css/Footer.css";
import { FaInstagram, FaRegEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footerContainer">
      <div className="footer">
        <div>thanks for supporting :)</div>
        <Link to="/faqs" className="faqs-link">
            FAQs
          </Link>
        <div className="footer-icons">
          <a
            href="https://www.instagram.com/couscouscollective"
            target="_blank"
            rel="noopener noreferrer"
            className="instagram"
          >
            <FaInstagram size={18} />
          </a>

          <a
            href="mailto:couscouscollective@outlook.com"
            className="email"
          >
            <FaRegEnvelope size={18} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
